import { Toaster as SonnerToaster } from "sonner";

function Toaster(): React.JSX.Element {
  return <SonnerToaster position="bottom-center" richColors closeButton />;
}

export { Toaster };
